import { render, staticRenderFns } from "./OrderRecurringPayments.vue?vue&type=template&id=33fd9273&"
import script from "./OrderRecurringPayments.vue?vue&type=script&lang=ts&"
export * from "./OrderRecurringPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports